import { config } from 'zod/v4/core'

// CSP стенда запрещает `eval`, а zod 4 пробует его при создании первой схемы и
// сыплет ошибкой в консоль. Без JIT схемы работают так же, чуть медленнее.
// Модуль должен импортироваться ПЕРВЫМ в точке входа: до загрузки `./App` и
// всего, что создаёт схемы на уровне модуля. Берём `config` из `zod/v4/core`,
// а не `z` из `zod`, чтобы не тянуть в чанк входа весь пакет.
config({ jitless: true })
